// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1E9Sd","messages":"Chat_messages__3GtjN","dateDivider":"Chat_dateDivider__YmUnQ"};